<template>
	<div class="wc-layout">
		<div class="col col1">
			<slot name="col1" />
		</div>
		<div class="col col2">
			<div class="col2-cnt">
				<slot name="col2" />
			</div>
		</div>
	</div>
</template>

<style lang="less">
	.page-webshop .to-top{display: none;}
</style>

<style scoped lang="less">
	.wc-layout{
		display: flex; gap: 24px; padding: 30px 0;
		@media (max-width: @m){padding: 25px 0 0; display: block;}
	}
	.col2{
		width: 465px; padding-top: 60px; position: sticky; top: -20px; align-self: flex-start;
		@media (max-width: @m){width: auto; padding-top: 0; margin: 0 calc((var(--wrapperMargin) * -1)); position: relative; top: 0;}
	}
	.col1{flex: 1;}
</style>